import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import "../Modules/protect/protect-page.css";
import "../Modules/redux/redux-page.css";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";

const features = [
	{ icon: "/brand/icons/dutch-made-quality.svg", title: "Dutch-made Quality", bullets: ["Designed and produced in the Netherlands"] },
	{ icon: "/brand/icons/custom-fit.svg", title: "Earbuds designed for maximum comfort", bullets: ["Tailored to your ear and crafted with additive manufacturing, ensuring a comfortable and secure fit."] },
	{ icon: "/brand/icons/hearing-protection.svg", title: "Hearing Protection", bullets: ["Noise Protection Level up to 19dB, 28dB, 30dB or 33dB"] },
	{ icon: "/brand/icons/safety.svg", title: "Lasting Safety", bullets: ["Available in various colors.", "All filters are X-ray & Metal detectable", "Separately available, Quick-release cord", "Hygienic, Easy-clean material", "Bio-compatible material"] },
];

const filters = [
	{ name: "White 20", img: "Redux-Filter_White", uses: ["Festivals", "Concerts", "Musicians", "Motorcycling", "Communication", "Water sports"] },
	{ name: "Yellow 20", img: "Redux-Filter_Yellow", uses: ["Low noise Industries", "DIY enthusiasts", "Festivals", "Concerts", "Musicians", "Motorcycling"] },
	{ name: "Red 25", img: "Redux-Filter_Red", uses: ["Medium noise Industries", "DIY enthusiasts", "Motorcycling", "Traveling", "Concentrate"] },
	{ name: "Purple 30", img: "Redux-Filter_Purple", uses: ["High noise Industries", "DIY enthusiasts", "Traveling", "Concentrate"] },
];

const photos = [
	{ src: "/images/redux/motorcycle.jpg", alt: "A motorcyclist on a country road" },
	{ src: "/images/redux/worker.jpg", alt: "A worker in a high-visibility jacket and hard hat" },
	{ src: "/images/redux/music.jpg", alt: "A festival visitor dancing in a crowd" },
];

export default function Redux() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Redux"}</title>
			</Helmet>
			<NavigationBar />

			<section className="eo-rhero eo-rhero--redux">
				<div className="eo-rhero__photos">
					{photos.map((p) => (
						<img key={p.src} src={p.src} alt={p.alt} />
					))}
				</div>
				<div className="eo-rhero__grid">
					<img className="eo-rhero__product" src="/images/redux/render-pair.png" alt="EarsOnly Redux earplugs" />
					<div className="eo-rhero__text">
						<img className="eo-redux__logo" src="/brand/wordmarks/earsonly-redux-black.svg" alt="EarsOnly Redux" />
						<p className="eo-pintro__lead">
							Custom-Fit Hearing protection. Redux earplugs are engineered for both professionals and dedicated enthusiasts who demand high performance and protection.
						</p>
						<div className="eo-pintro__actions">
							<a className="eo-button eo-button--accent" href="/contact">Order</a>
						</div>
					</div>
				</div>
			</section>

			<Container className="eo-pfeatures">
				<p className="eo-section__overline">Features</p>
				<h2 className="eo-section__title">What makes EarsOnly Redux different?</h2>
				<div className="eo-features">
					{features.map((f) => (
						<div className="eo-feature" key={f.title}>
							<img className="eo-feature__icon" src={f.icon} alt="" />
							<h3 className="eo-feature__title">{f.title}</h3>
							<ul className="eo-feature__list">
								{f.bullets.map((b) => (
									<li key={b}>{b}</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</Container>

			<section className="eo-pspec eo-redux__colors">
				<Container>
					<p className="eo-section__overline">Colors and levels</p>
					<h2 className="eo-section__title">Made to match you.</h2>
					<div className="eo-redux__colors-grid">
						<img src="/images/cradle_and_buds/Redux color options.png" alt="Redux earplugs in blue, red, black and orange" loading="lazy" />
						<p>Redux passive hearing protection comes in various materials, styles, colors, and protection levels. Contact us for a tailored proposal.</p>
					</div>
				</Container>
			</section>

			<Container className="eo-redux__filters">
				<p className="eo-section__overline">Filters</p>
				<h2 className="eo-section__title">Exchangeable filters</h2>
				<div className="eo-redux__filter-grid">
					{filters.map((f) => (
						<div className="eo-redux__filter" key={f.name}>
							<div className="eo-redux__filter-image">
								<img src={`/images/cradle_and_buds/${f.img}.png`} alt={`${f.name} filter`} loading="lazy" />
							</div>
							<h3 className="eo-feature__title">{f.name}</h3>
							<ul className="eo-feature__list">
								{f.uses.map((u) => (
									<li key={u}>{u}</li>
								))}
							</ul>
						</div>
					))}
				</div>
				<div className="eo-redux__filters-note">
					<p>These examples represent just a selection of our possibilities. For additional use-cases and information consult our specialists.</p>
					<a className="eo-button eo-button--accent" href="/contact">Contact</a>
				</div>
			</Container>
			<Footer />
		</>
	);
}
